import { ProfileConfig, AuthProfileConfig } from './types';

export const publicPortalConfig: ProfileConfig = {
  id: 'public-portal',
  name: 'Herx.org Freemium Public Portal',
  targetEnvironment: 'cloud_portal',
  branding: {
    id: 'public-portal',
    name: 'Herx Freemium Portal',
    tagline: 'Community & Fine Art Cloud Showcase',
    logoUrl: '/assets/logo-portal.svg',
    colors: {
      primary: '#a855f7',
      accent: '#38bdf8',
      bg: '#05080f',
      card: '#0f172a',
    },
  },
  features: {
    showPrices: false, // Role-gated price privacy on public portal
    allowArtworkInquiry: true,
    allowCertificateView: false,
    allowAgentExecution: false,
    allowPosTerminal: false,
    allowKioskCheckout: false,
    allowAdminControls: false,
    multiTenancyMode: 'multi_tenant_pool',
  },
  capabilities: [
    'gallery:view',
    'inventory:artwork:view_public',
    'cms:read',
    'leads:submit',
  ],
  enabledModules: [
    { id: 'com.mesh.gallery', name: 'Fine Art Showcase', capabilities: ['gallery:view'], autoMount: true },
    { id: 'com.mesh.cms', name: 'Public Landing Pages', capabilities: ['cms:read'], autoMount: true },
  ],
  routes: ['/', '/login', '/onboarding', '/leads', '/admin'],
  auth: {
    onboardingMode: 'invite-only',
    inviteRequired: true,
    // Launch: Google OIDC only. Facebook can be added later via config — no code change needed.
    allowedSignupMethods: ['email-ota', 'oidc-google'],
    allowedLoginMethods: ['biometric', 'oidc-google', 'email-ota', 'device-qr'],
    invitePolicy: {
      ttlHours: 72,           // 3-day validity window
      maxRedemptions: 1,      // Single-use
      issuerRole: 'superadmin', // Only super-admins issue invites at launch
      bindToEmail: true,      // Redemption email must match invite boundEmail
    },
    sessionPolicy: {
      allowMultipleSessions: true,
      maxConcurrentSessionsPerUser: 3,
      requireDeviceBinding: true,
      requireStepUpForNewDevice: true,
      stepUpMethod: 'email-otp', // Simple email-OTP step-up for v1.0; QR companion in future
    },
  } satisfies AuthProfileConfig,
};
